import { marker } from '@jsverse/transloco-keys-manager/marker';
import { DialogPlugin } from '@modules/forms/models/dialog-plugin';
import { ModuleId } from '@pixacare/forms';
import { UserIdentityModuleComponentByModuleId } from '../models/user-identity-module-component-by-module-id';
import { UserIdentitySupportedModuleIds } from '../models/user-identity-supported-module-ids';
import { UserIdentityComponent } from '../modules/user-identity/components/user-identity.component';

type UserIdentityModules = {
  [M in UserIdentitySupportedModuleIds]: DialogPlugin<UserIdentityModuleComponentByModuleId[M]>;
};

export const userIdentityModules = {
  [ModuleId.USER_IDENTITY]: {
    id: ModuleId.USER_IDENTITY,
    component: UserIdentityComponent,
    dependencies: [],
    inputs: {},
    outputs: {
      id: 'id',
      firstName: 'firstName',
      lastName: 'lastName',
      fullName: 'fullName',
      mailAddress: 'mailAddress',
    },
    config: {
      label: marker("Renseigner l'identité"),
      size: 'm',
    },
  },
} satisfies UserIdentityModules;
